<template>
  <div v-cloak class="modal">
    <div class="form">
      <div class="form__close" @click="handlerAssetsForm">
        <img src="https://sirv.sirv.com/website/theme2/icon/close.svg" alt="Close modal" />
      </div>
      <div class="form__control">
        <div class="title">Paste the URLs of your Sirv assets or .view</div>
        <el-input
          id="textArea"
          ref="textArea"
          v-model="urls"
          type="textarea"
          :rows="7"
          resize="none"
          :trigger-on-focus="true"
          :placeholder="placeholder"
          :autofocus="true"
        />
        <div v-show="errorStatus" class="form__error">
          {{ error }}
        </div>
      </div>

      <div class="form__actions">
        <button class="btn" @click="addAsset">Use assets</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { prefetchAccountLink, loadPrefetchToPage } from "@/utils/prefetch";
import itemErrors from "@/store/observable/item-errors";

export default {
  data() {
    return {
      error: "",
      errorStatus: false,
      urls: "",
      placeholder:
        `e.g. \nhttps://demo.sirv.com/example.spin` +
        `\nhttps://demo.sirv.com/example-image.jpg` +
        `\nhttps://demo.sirv.com/another-example-image.jpg`,
    };
  },
  computed: {
    ...mapState(["statusAssetsForm"]),
    itemErrors,
    ...mapGetters({
      getDataCount: "getDataCount",
      defaultUrls: "textarea/defaultUrls",
    }),
  },
  watch: {
    statusAssetsForm(val) {
      this.$refs.textArea.focus();
    },
    defaultUrls(val) {
      this.urls = val;
    },
  },
  methods: {
    handlerAssetsForm() {
      this.$store.dispatch("showAssetsForm", false);
    },
    clearUrls() {
      this.urls = "";
    },
    addAsset() {
      this.$store.dispatch("changeViewSMVMode", false);
      this.$store.dispatch("spinControl/changeSpinControlPanelSettings", {
        selectedButtons: [],
        selectedPosition: [],
        selectedIconsStyle: [],
        status: false,
      });

      this.errorStatus = false;
      this.error = "";

      const VIDEO_FORMATS = `(${[
        "\\.mp4",
        "youtube\\.com",
        "vimeo\\.com",
        "\\.mov",
        "\\.mpg",
        "\\.mpeg",
        "\\.wmv",
        "\\.avi",
        "\\.webm",
        "\\.mkv",
        "\\.m4v",
      ].join(")|(")})`;

      const stringUrls = this.urls;
      const httpsRegEx = new RegExp(
        "(^|[ \t\r\n])(https:(([A-Za-z0-9$_.+!*(),;/?:@&~=-])|%[A-Fa-f0-9]{2}){2,}(#([a-zA-Z0-9][a-zA-Z0-9$_.+!*(),;/?:@&~=%-]*))?([A-Za-z0-9$_+!*();/?:~-]))",
        "g"
      );
      const typeJPGRegEx = new RegExp("(\\.jpg)", "ig");
      const typeSpinRegEx = new RegExp("(\\.spin)", "ig");
      const typeVideoRegEx = new RegExp(VIDEO_FORMATS, "ig");
      const typeViewRegEx = new RegExp("(\\.view)", "ig");
      const typeModelRegEx = new RegExp("(\\.glb)|(\\.gltf)", "ig");

      const sirvHTTPRegEx = new RegExp("https://", "ig");
      let arrayUrls = stringUrls.split("\n");
      arrayUrls = arrayUrls.filter((i) => i !== "");

      if (arrayUrls.length > 51) {
        this.errorStatus = true;
        this.error = `Limit of urls are exceeded. Paste less 50 urls.`;
        return false;
      }

      const youTubeRegEx = new RegExp("youtube.com", "ig");
      const vimeoRegEx = new RegExp("vimeo.com", "ig");

      const filterArrayUrls = arrayUrls.map((arrayItem, index) => {
        if (arrayItem.match(sirvHTTPRegEx) !== null && arrayItem !== "") {
          return arrayItem;
        } else {
          this.errorStatus = false;
          return arrayItem.replace("http://", "https://");
        }
      });

      const checkViewAssets = filterArrayUrls.find((arrayItem) => arrayItem.match(typeViewRegEx));

      // if (checkViewAssets !== undefined && filterArrayUrls.length !== 1) {
      //   this.errorStatus = true;
      //   this.error += `You should insert one url .view`;
      //   return false;
      // }

      if (this.errorStatus === true) {
        return;
      }

      let createId = parseInt(`${this.getDataCount}`);
      let mapDataUrls;

      mapDataUrls = filterArrayUrls.map((arrayItem) => {
        let type = "image";
        if (arrayItem.match(typeJPGRegEx) !== null) {
          type = "image";
        }
        if (arrayItem.match(typeSpinRegEx) !== null) {
          type = "spins";
        }
        if (arrayItem.match(typeVideoRegEx) !== null) {
          type = "video";
        }
        if (arrayItem.match(typeModelRegEx) !== null) {
          type = "model";
        }
        if (arrayItem.match(typeViewRegEx) !== null) {
          type = "view";
        }

        if (type === "video") {
          let yThumbnail = null;
          let vThumbnail = null;

          if (arrayItem.match(youTubeRegEx) !== null) {
            yThumbnail = "https://sirv.sirv.com/website/theme2/icon/youtube-brands.svg";
          }

          if (arrayItem.match(vimeoRegEx) !== null) {
            vThumbnail = "https://sirv.sirv.com/website/theme2/icon/vimeo-brands.svg";
          }

          return {
            id: ++createId,
            src: arrayItem.trim(),
            type: type,
            yThumbnail: yThumbnail,
            vThumbnail: vThumbnail,
            title: `Custom asset ${createId}`,
            added: true,
          };
        } else if (type === "spins") {
          return {
            id: ++createId,
            src: arrayItem.trim(),
            type: type,
            spinsrc: arrayItem.trim(),
            title: `Custom asset ${createId}`,
            added: true,
          };
        } else if (type === "view") {
          return {
            id: ++createId,
            src: arrayItem.trim(),
            type: type,
            title: `Custom asset ${createId}`,
            added: true,
          };
        } else {
          return {
            id: ++createId,
            src: arrayItem.trim(),
            type: type,
            title: `Custom asset ${createId}`,
            added: true,
          };
        }
      });

      if (mapDataUrls.length) {
        let account = new URL(mapDataUrls[0].src).origin;
        prefetchAccountLink.value = account;
        loadPrefetchToPage();
      }
      this.$store.dispatch("addCustomAssets", mapDataUrls);
      this.$store.dispatch("refreshSMV", mapDataUrls);

      itemErrors
        .get()
        .filter((item) =>
          !mapDataUrls.find((url) => item.src === url.src)
            ? itemErrors.remove(item.src)
            : itemErrors.update(item.src, true)
        );

      this.handlerAssetsForm();
    },
  },
};
</script>
<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
.modal {
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, 0.7);
  width: 100%;
  height: 100%;
  z-index: 1999;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-select-dropdown.el-popper {
    z-index: 99999 !important;
  }
}
.title {
  color: #6c7683;
  margin-bottom: 15px;
}
.form__control {
  position: relative;
  z-index: 2000;
  margin-bottom: 20px;
}
.form__actions {
  display: flex;
  justify-content: center;

  .btn {
    padding: 12px 40px;
    margin: 0 10px;
    border-radius: 8px;
    background-color: #327bba;
    color: #fff;
    outline: none;
    border: none;
    font-size: 16px;
    transition: opacity 0.5s ease;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
.form {
  position: relative;
  max-width: 500px;
  width: 100%;
  background-color: #fff;
  min-height: 250px;
  z-index: 2000;
  padding: 40px 30px;
  box-shadow: 0 8px 40px rgba(50, 123, 186, 0.16), 0 4px 4px rgba(50, 123, 186, 0.08);

  &__close {
    cursor: pointer;
    position: absolute;
    width: 25px;
    height: 25px;
    right: 10px;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;
    img {
      width: 25px;
      height: 25px;
    }
  }
  &__error {
    margin: 5px 0;
    color: #f56c6c;
  }
}
</style>
>
